export default __webpack_public_path__ + "static/media/sub.de2caf1f.png";